// extracted by mini-css-extract-plugin
export var dropdown = "_vt-0";
export var imageWrapper = "_vt-3";
export var itemNameContainer = "_vt-1";
export var productImage = "_vt-2";
export var spinnerWrapper = "_vt-4";